import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { FromStandardIconProps } from "models/propTypes/customerPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Icon, SimpleTooltip } from "components/common";
import { InputAdornment } from "@mui/material";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FromStandardIcon: React.FC<FromStandardIconProps> = ({ value }) => {
  return UtilsHelper.isEmpty(value) ? (
    <InputAdornment position="end" className={clsx(cssExports.inputAdornedEnd, cssExports.info)}>
      <SimpleTooltip
        text={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.InheritsStandard)}
        placement="top"
      >
        <div>
          <Icon icon={IconDefinitionConstants.WLink} className={cssExports.inputIcon} />
        </div>
      </SimpleTooltip>
    </InputAdornment>
  ) : (
    <></>
  );
};

export default FromStandardIcon;
